export enum SingleOrderChannel {
  CREATE = 'singleOrder::create',
  EDIT = 'singleOrder::patch',
  DELETE = 'singleOrder::delete',
}
